import { Partial } from '@40seas/entities/common';
import { NotificationDefinitionEventType } from './notification-definition-event-type.entity';

export class UpdateNotificationDefinitionEventType extends Partial(NotificationDefinitionEventType) {}
